import {
    temAcesso
} from '@/shared/auth/temAcesso'

const Certidoes = () => import('./Certidoes.vue')

export default {
    path: 'certidoes',
    name: 'FornecedorCertidoes',
    component: Certidoes,
    beforeEnter: (to, from, next) => {
        if (temAcesso('FORN-CERT-00')) {
            next()
        }
    }
    // children: [{
    //     path: 'atualizar',
    //     name: 'FornecedorDadosCadastrais_Atualizar',
    //     component: DadosCadastraisForm,
    //     beforeEnter: (to, from, next) => {
    //         if (temAcesso('FORN-DADOS-01')) {
    //             next()
    //         }
    //     }
    // }]
}
